import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { getCurrentDate } from '../../../helpers/Common';
import {
  REDUCER_NAME,
  downloadAllScore,
  downloadRanking,
  downloadIndicators,
} from '../reducer';
import ExportBlob from '../../../common/export-blob';
import RankingConst from '../Const';

class ExportCommon extends React.Component {
  getComGroupCode = () => {
    const { currentTabAllScore } = this.props;
    const mapComGroupCode = {
      [RankingConst.listTabFilterAllScore.all]: '',
      [RankingConst.listTabFilterAllScore.HOSE]: 'VNIndex',
      [RankingConst.listTabFilterAllScore.HNX]: 'HnxIndex',
    };
    return mapComGroupCode[currentTabAllScore];
  };

  handleExport = () => {
    const {
      page,
      downloadAllScore,
      downloadRanking,
      downloadIndicators,
    } = this.props;
    if (page === 'ranking') {
      const {
        isRankingsIndicators,
        industryId,
        pageNumber,
        listIndustryByIcbLevel,
      } = this.props;
      const apiParam = {
        Page: pageNumber,
        Code: industryId,
      };
      const industries = listIndustryByIcbLevel
        ? listIndustryByIcbLevel[3]
        : [];
      const rankGroup = industries.find(item => {
        return item.icbCode === industryId;
      });
      const exportName = I18n.t('common.export.ranking.fiinTradeRankings', {
        date: getCurrentDate(),
        group: rankGroup ? rankGroup.icbName : industryId,
      });

      if (!isRankingsIndicators) return downloadRanking(apiParam, exportName);
      downloadIndicators(apiParam, exportName);
    }

    if (page === 'score') {
      const {
        pageNumber,
        // industryId,
        currentSelectedIndustryTable,
        currentTabAllScore,
      } = this.props;

      const ComGroupCode = this.getComGroupCode();
      const { icbCode: IcbCode } = currentSelectedIndustryTable;
      const apiParam = {
        Page: pageNumber,
        // icbCode: industryId,
        ComGroupCode,
        IcbCode: IcbCode === 'all' ? null : IcbCode,
      };
      const currentTab = (currentTabAllScore ===
      RankingConst.listTabFilterAllScore.all
        ? 'all'
        : currentTabAllScore
      ).toLowerCase();
      const exportName = I18n.t(`common.export.ranking.${currentTab}`, {
        date: getCurrentDate(),
      });
      downloadAllScore(apiParam, exportName);
    }
  };

  render() {
    return <ExportBlob handleExport={this.handleExport} />;
  }
}

const mapStateToProps = state => {
  return {
    currentTabAllScore: state[REDUCER_NAME].currentTabAllScore,
    pageNumber: state[REDUCER_NAME].page,
    currentSelectedIndustryTable:
      state[REDUCER_NAME].currentSelectedIndustryTable,
    listIndustryByIcbLevel: state[COMMON_REDUCER_NAME].listIndustryByIcbLevel,
  };
};

const mapDispatchToProps = {
  downloadAllScore,
  downloadRanking,
  downloadIndicators,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExportCommon);
